import { getRoleDisplayName } from "../user/get-role";
import {capitalizeWords} from '../utils';

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true // for 12-hour format. If you want 24-hour format, set this to false or remove this line.
  };
  return date.toLocaleDateString(undefined, options);
};

export const seperateFieldsForGuestListReports = (originalArray) => {
  const modifiedArray = originalArray.map((item) => {
    let paidPrice = item.transaction?.paidPrice;
    let purchasedAdditional =
      (item?.ownerEmail === item.email || !item?.ownerEmail) &&
      item?.transaction?.additionalTicketQuanitity > 0;

    let purchasedTicketsQuanitity =
      (item?.purchasedAdditionalTicketQuantity ?? 0) + 1;
    let singleTicketPrice = paidPrice / purchasedTicketsQuanitity;
    let additionalTicketsPrice =
      singleTicketPrice * (item.purchasedAdditionalTicketQuantity ?? 0);

    let finalPrice =
      item?.isAdditionalTicket === true
        ? singleTicketPrice
        : purchasedAdditional
        ? singleTicketPrice + additionalTicketsPrice
        : paidPrice;

    let isPaidAtDoor =
      item.transaction === undefined || item.transaction === null;

    return {
      Event: item.event.eventName,
      Name: item.isExpressEntry
        ? capitalizeNames(item.fullName || '')
        : item?.fullName || '',
      Email: item.isExpressEntry ? item.email || '' : item?.email || '',
      InvitedBy: capitalizeNames(
        item.member
          ? item.member.fullName || ''
          : item.invitedBy
          ? item.invitedBy.fullName || ''
          : ''
      ),
      Role: getRoleDisplayName(
        item.member
          ? item.member.userType || ''
          : item.invitedBy
          ? item.invitedBy.userType || ''
          : ''
      ),
      Type: capitalizeWords(
        item?.type ? item?.type : item?.ticket?.ticketType?.name ?? 'Prepaid'
      ),
      Code: item.code,
      Status:
        item?.transaction?.paymentStatus === 'refunded'
          ? 'Refunded'
          : item.hasOwnProperty('isVerified')
          ? 'Pending'
          : 'Verified',
      Date: formatDate(item.createdAt),
      TicketPrice: `${!isPaidAtDoor ? singleTicketPrice.toFixed(1) : '-'}`,
      TotalPaid: `${
        item.isAdditionalTicket
          ? `Paid by ${item.ownerEmail}`
          : `${!isPaidAtDoor ? finalPrice.toFixed(1) : 'Paid at door'}`
      }`,
      'Purchased Additional':
        purchasedAdditional === true
          ? `${item?.purchasedAdditionalTicketQuantity ?? 0}`
          : ''
    };
  });
  return modifiedArray;
};

export const capitalizeNames = (fullName) => {
  const names = fullName.split(" ");
  const capitalizedNames = names.map(
    (name) => name.charAt(0).toUpperCase() + name.slice(1)
  );
  return capitalizedNames.join(" ");
};
